(function (root) {
  function cleanQuantity(value) {
    const n = Number(value);
    return Number.isFinite(n) ? Math.min(99, Math.max(0, Math.floor(n))) : 0;
  }
  function normalize(state) {
    const result = {};
    for (const key of ['timeline','stand','magnifier']) result[key] = cleanQuantity(state && state[key]);
    return result;
  }
  function timelineTotal(quantity) {
    const n = cleanQuantity(quantity);
    return Math.floor(n / 3) * 9995 + [0,3995,6995][n % 3];
  }
  function calculate(raw) {
    const state = normalize(raw);
    const lines = [];
    if (state.timeline) lines.push({key:'timeline', quantity:state.timeline, total:timelineTotal(state.timeline), original:state.timeline * 5995});
    if (state.stand) lines.push({key:'stand', quantity:state.stand, total:state.stand * (state.timeline ? 1995 : 2850), original:state.stand * 2850});
    if (state.magnifier) lines.push({key:'magnifier', quantity:state.magnifier, total:state.magnifier * (state.timeline ? 2495 : 3564), original:state.magnifier * 3564});
    const total = lines.reduce((sum,line)=>sum+line.total,0);
    const original = lines.reduce((sum,line)=>sum+line.original,0);
    return {state,lines,total,original,savings:original-total,count:lines.reduce((sum,line)=>sum+line.quantity,0)};
  }
  root.AdamsDraftMath = {normalize,cleanQuantity,timelineTotal,calculate};
})(typeof window === 'undefined' ? globalThis : window);
